/*
 * Returns a breadcrumb path string for the given inputs.
 * This is a pure function (no side effects).
 *
 * @param {Object} params
 * @param {string} params.label
 * @param {string} [params.searchKey]
 * @param {string} [params.searchType] - key into searchReverseParams
 * @param {string} [params.siteUUID]
 * @param {string} [params.contractcode]
 * @param {string} [params.resolvedDefaultStartIn]
 * @param {string} [params.bundle]
 * @param {string} [params.groupId] - selected group id to preserve when
 *        navigating back to the Site Details page (appended as `grpId`)
 * @param {string} [params.groupId] - appended as grpId query param to site URLs
 * @param {string} [params.savedPath] - preferred over reading sessionStorage here
 * @returns {}
 */

import {
  BREADCRUMB_LABELS,
  initialStartIn,
  searchReverseParams,
} from '../constants';

export function getBreadcrumbPath({
  label,
  searchKey,
  searchType,
  siteUUID,
  contractcode,
  resolvedDefaultStartIn,
  bundle,
  groupId,
  savedPath,
}) {
  switch (label) {
    case BREADCRUMB_LABELS.HOME: {
      return '/home';
    }

    case BREADCRUMB_LABELS.SEARCH: {
      const hasType =
        searchType && searchReverseParams && searchReverseParams[searchType];
      const hasQuery = Boolean(searchKey) && Boolean(hasType);
      if (!hasQuery) return '/search';

      const q = encodeURIComponent(searchKey);
      const type = encodeURIComponent(searchReverseParams[searchType]);
      return `/search?q=${q}&type=${type}&useCache=true`;
    }

    case BREADCRUMB_LABELS.SITE: {
      if (!siteUUID || !contractcode || !resolvedDefaultStartIn) return '';

      const grpIdParam = groupId ? `?grpId=${groupId}` : '';

      if (resolvedDefaultStartIn === initialStartIn) {
        const pathSegment = savedPath || 'active';
        return `/${siteUUID}/${contractcode}/site-details/pai/${pathSegment}${grpIdParam}`;
      }

      // resolvedDefaultStartIn !== initialStartIn
      return `/${siteUUID}/${contractcode}/site-details/ais/active${grpIdParam}`;
    }

    case BREADCRUMB_LABELS.TRENDS_VIEW: {
      return bundle ? `/${bundle}/trends-view` : '';
    }

    default:
      return '';
  }
}
